import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box, Stack } from '@mui/material';
import { C, DETAIL_CARD_SX } from '../tokens';
import { fmtNum, fmtPct } from '../formatters';
import { DataLine, SectionLabel } from '../atoms';
import ScoreBreakdown from '../ScoreBreakdown';

// Score component bar + supporting numeric rows.
const DetailComponentsCard = ({ detailDrawer, t }) => (
  <Box sx={DETAIL_CARD_SX}>
    <Box sx={{
      px: 1.4,
      py: 1,
      bgcolor: alpha(C.violet, 0.04),
      borderBottom: `1px solid ${alpha(C.violet, 0.12)}`,
    }}>
      <SectionLabel>{t('breakoutCandidates.drawer.components')}</SectionLabel>
    </Box>
    <Box sx={{ px: 1.4, py: 1.1 }}>
      <ScoreBreakdown comp={detailDrawer.components || {}} t={t} />
      <Stack
        spacing={0}
        sx={{
          mt: 1,
          '& > *:not(:last-child)': { borderBottom: `1px solid ${alpha(C.border, 0.8)}` },
        }}
      >
        <DataLine
          k={t('breakoutCandidates.drawer.sectorRs')}
          v={fmtPct(detailDrawer.sector_metrics?.sector_rs)}
        />
        <DataLine
          k={t('breakoutCandidates.drawer.sectorValue')}
          v={`${fmtNum(detailDrawer.sector_metrics?.sector_value_ratio, 2)}x`}
        />
        <DataLine
          k={t('breakoutCandidates.drawer.trapPenalty')}
          v={fmtNum(detailDrawer.components?.trap_penalty, 1)}
        />
        <DataLine
          k={t('breakoutCandidates.drawer.riskPenalty')}
          v={fmtNum(detailDrawer.strength?.risk_penalty_score, 1)}
        />
      </Stack>
    </Box>
  </Box>
);

DetailComponentsCard.propTypes = {
  detailDrawer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  t: PropTypes.func.isRequired,
};

export default DetailComponentsCard;
